export const mobileNavOverlay = 1;
export const mobileMenu = 2;